export default `제1조 (목적)

이 약관은 주식회사 프리플랍(이하 “회사”)이 제공하는 프리플랍 애플리케이션 및 관련 제반 서비스(이하 “서비스”)의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.

제2조 (정의)

이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
1. “서비스”란 구현되는 단말기(PC, 스마트폰, 태블릿 등 모든 유무선 장치 포함)와 상관없이 회원이 이용할 수 있는 프리플랍 애플리케이션 및 관련 제반 기능(홀덤 대회 정보, 미디어 콘텐츠, 커뮤니티 기능 등)을 의미합니다.
2. “회원”이란 회사의 서비스에 접속하여 이 약관에 동의하고, 회사와 이용계약을 체결하여 서비스를 이용하는 자를 말합니다.
3. “아이디(ID)”란 회원의 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인한 문자 또는 숫자의 조합을 말합니다.
4. “비밀번호”란 아이디와 일치되는 회원임을 확인하고 회원의 개인정보 보호를 위하여 회원이 설정한 문자 또는 숫자의 조합을 말합니다.
5. “유료서비스”란 회사가 유료로 제공하는 콘텐츠, 이벤트 참가 등 각종 유료 기능 및 서비스를 의미합니다.
6. “티켓(매장이용권, 포인트, 시드권, 참여권, 포인트 등)”이란 회원이 서비스 내에서 일정 조건을 충족하거나 기타 대회 또는 이벤트 등을 통해 획득할 수 있는 데이터로, 현금 가치가 없으며 회사 정책에 따라 부여 및 회수될 수 있는 가상의 수치입니다.
7. “게시물”이란 회원 또는 회사가 서비스 상에 업로드하거나 등록한 텍스트, 이미지, 동영상, 링크, 댓글 등 일체의 콘텐츠를 말합니다.

제3조 (약관의 게시와 개정)

1. 회사는 이 약관의 내용을 회원이 쉽게 확인할 수 있도록 서비스 초기 화면에 게시합니다.
2. 회사는 『약관의 규제에 관한 법률』, 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』(이하 "정보통신망법") 등 관련 법령을 위반하지 않는 범위 내에서 이 약관을 개정할 수 있습니다.
3. 회사가 약관을 개정하는 경우에는 적용일자 및 개정 사유를 명시하여 현행 약관과 함께 앱 내 공지사항 등을 통해 개정 약관의 적용일 30일 전부터 적용일 전일까지 공지합니다. 다만, 회원에게 불리한 변경일 경우, 푸시 알림, 로그인 시 동의창, 이메일 또는 쪽지 등 별도의 전자적 수단을 통해 명확히 통지합니다.
4. 회사는 전 항에 따라 개정 약관을 공지 또는 통지하면서, 회원에게 “30일 이내에 명시적인 거부 의사를 표시하지 않으면 동의한 것으로 간주된다”는 내용을 함께 고지한 경우, 회원이 명시적으로 거부의사를 표시하지 않으면 개정 약관에 동의한 것으로 봅니다.
5. 회원이 개정 약관의 적용에 동의하지 않는 경우, 회사는 해당 회원에게 기존 약관을 적용하기 어렵다는 사정이 있는 경우 이용계약을 해지할 수 있으며, 회원 역시 이용계약을 해지할 수 있습니다.

제4조 (약관의 해석)

1. 회사는 유료서비스 및 개별 서비스에 대해 별도의 이용약관, 정책 또는 운영규칙(이하 “유료서비스 약관 등”)을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 해당 유료서비스 약관 등이 우선하여 적용됩니다. (예: 유료 포인트 사용정책, 대회 참가 규칙, 커뮤니티 운영정책 등)
2. 이 약관에서 정하지 아니한 사항이나 해석에 대해서는 유료서비스 약관 등, 관계법령 및 일반적인 상관례에 따릅니다.

제5조 (이용계약 체결)

1. 이용계약은 프리플랍 서비스의 회원이 되고자 하는 자(이하 “가입신청자”)가 이 약관의 내용에 동의하고, 회원가입 신청을 한 후, 회사가 이를 승인함으로써 성립됩니다.
2. 회사는 가입신청자의 신청에 대해 원칙적으로 서비스를 이용할 수 있도록 승낙합니다. 다만, 다음 각 호에 해당하는 경우에는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
    2.1. 이전에 본 약관 또는 운영정책 위반 등으로 회원 자격이 정지 또는 상실된 이력이 있는 경우 (단, 회사의 재가입 승낙을 얻은 경우는 예외)
    2.2. 실명이 아니거나 타인의 명의로 신청한 경우
    2.3. 허위 정보를 기재하거나 필수 정보를 누락한 경우
    2.4. 기타 회사가 정한 기준에 위반되거나 승인할 수 없는 사유가 있는 경우
3. 회사는 필요에 따라 회원의 종류 또는 이용 범위에 따라 본인 인증 또는 실명 확인을 요구할 수 있습니다.
4. 회사는 다음 각 호에 해당하는 경우 회원가입 신청의 승낙을 유보할 수 있습니다.
    4.1. 서비스 관련 설비의 여유가 없거나,
    4.2. 기술상 또는 업무상 지장이 있는 경우,
    4.3. 기타 회사의 정책상 필요하다고 판단되는 경우
5. 회사는 제2항 및 제4항에 따라 신청을 거절하거나 승낙을 유보하는 경우, 원칙적으로 그 사실을 가입신청자에게 알립니다.
6. 이용계약은 회사가 가입 완료를 서비스 화면(또는 이메일 등)을 통해 표시한 시점에 성립된 것으로 봅니다.
7. 회사는 회원에 대해 회사 정책에 따라 등급별로 구분하여 이용 가능 시간, 이용 횟수, 서비스 메뉴, 이벤트 참여 권한 등을 세분화하거나 차등을 둘 수 있습니다.

제6조 (회원정보의 변경)

1. 회원은 프리플랍 앱 내 설정 메뉴를 통해 언제든지 자신의 개인정보를 열람하고 수정할 수 있습니다. 다만, **서비스 관리상 필요하거나 본인 확인용으로 사용되는 정보(예: 아이디, 본인 인증 정보 등)**는 수정이 제한될 수 있습니다.
2. 회원은 회원가입 시 기재한 정보에 변경이 있을 경우, 앱 내 수정 기능 또는 이메일 등 회사가 정한 방법으로 즉시 변경사항을 반영하거나 회사에 통지해야 합니다.
3. 제2항에 따른 변경사항을 회원이 회사에 알리지 않음으로써 발생한 불이익(예: 서비스 제한, 고지 미수신 등)에 대해서는 회사가 책임지지 않습니다.

제7조 (개인정보보호 의무)

회사는 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『개인정보 보호법』 등 관련 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 회원의 개인정보 보호 및 사용에 관해서는 관계 법령과 회사의 ‘개인정보처리방침’이 적용됩니다.

단, 회사에서 제공하는 공식 앱 또는 웹페이지 이외에 외부로 연결된 링크(예: 제휴사 페이지, 외부 광고 등)에서는 회사의 개인정보처리방침이 적용되지 않으며, 이에 대해서는 회사가 책임지지 않습니다.

제8조 (회원의 아이디 및 비밀번호 관리 의무)

1. 회원의 **아이디(ID)**와 비밀번호에 대한 관리 책임은 전적으로 회원 본인에게 있으며, 이를 제3자에게 이용하게 해서는 안 됩니다.
2. 회사는 다음 각 호에 해당하는 경우, 해당 아이디의 사용을 제한하거나 변경을 요청할 수 있습니다.
    2.1. 개인정보 유출이 우려되는 경우
    2.2. 반사회적 표현, 비속어 또는 공공질서 및 미풍양속에 반하는 경우
    2.3. 회사 또는 운영자 등으로 오인될 우려가 있는 경우
3. 회원은 자신의 아이디 및 비밀번호가 도용되었거나 제3자가 무단으로 사용하고 있음을 인지한 경우, 즉시 회사에 그 사실을 알리고 회사의 안내에 따라야 합니다.
4. 회원이 제3항의 의무를 이행하지 않거나, 회사에 통지한 후에도 회사의 보안조치 또는 안내에 따르지 않아 발생한 손해에 대해서는 회사가 책임지지 않습니다.

제9조 (회원에 대한 통지)

1. 회사가 회원에게 개별 통지를 하는 경우, 이 약관에 특별한 규정이 없는 한 회원이 등록한 이메일 주소, 앱 내 알림센터, 전자 쪽지 또는 푸시 알림 등의 수단을 통해 통지할 수 있습니다.
2. 회사는 회원 전체에 대한 통지의 경우, 프리플랍 앱 내 '공지사항' 화면에 7일 이상 게시함으로써 제1항의 개별 통지에 갈음할 수 있습니다. 단, 회원에게 중대한 영향을 미치는 사항은 별도로 개별 통지할 수 있습니다.

제10조 (회사의 의무)

1. 회사는 관련 법령 및 본 약관이 금지하거나 공공질서 및 미풍양속에 반하는 행위를 하지 않으며, 지속적이고 안정적인 서비스 제공을 위해 최선을 다합니다.
2. 회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보 보호를 위한 보안시스템을 갖추고, 개인정보처리방침을 수립하여 이를 공개하고 성실히 준수합니다.
3. 회사는 서비스 이용과 관련하여 발생하는 회원의 불만 또는 피해구제 요청을 신속하고 적절하게 처리할 수 있도록 필요한 인력과 시스템을 운영합니다.
4. 회사는 회원이 제기한 의견이나 불만이 정당하다고 판단될 경우 이를 신속히 처리하며, 그 처리 결과는 앱 내 알림, 이메일, 고객센터 등을 통해 회원에게 전달합니다.

제11조 (회원의 의무)

1. 회원은 서비스를 이용함에 있어 다음 각 호의 행위를 하여서는 안 됩니다.
    1.1. 회원가입 또는 정보 변경 시 허위 내용을 기재하는 행위
    1.2. 타인의 개인정보 또는 계정 정보를 무단으로 도용하는 행위
    1.3. 회사가 게시한 정보를 무단으로 변경하거나 삭제하는 행위
    1.4. 회사가 정하지 않은 정보(컴퓨터 프로그램, 광고 링크 등)를 서비스에 게시하거나 송신하는 행위
    1.5. 회사 또는 제3자의 저작권, 상표권 등 지적재산권을 침해하는 행위
    1.6. 회사 또는 제3자의 명예를 훼손하거나 업무를 방해하는 행위 외설적이거나 폭력적인 내용, 혐오 표현, 기타 공공질서 및 미풍양속에 반하는 콘텐츠를 게시 또는 유포하는 행위
    1.7. 회사의 사전 동의 없이 서비스를 영리 목적으로 이용하는 행위
    1.8. 기타 관련 법령, 본 약관 또는 공서양속에 반하는 행위
2. 회원은 관계 법령, 본 약관, 서비스 내 안내사항, 회사가 별도로 고지하는 정책 등을 준수하여야 하며, 회사의 정상적인 업무를 방해하거나 서비스의 질을 저해하는 행위를 해서는 안 됩니다.
3. 회원이 프리플랍의 커뮤니티 기능, 게시판, 채널 등을 이용하여 상품 판매 또는 유사한 상업 활동을 하는 경우, 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관련 법령에 따른 의무를 성실히 이행해야 하며, 회사는 해당 내용에 대해 별도의 운영정책 또는 이용약관을 통해 규정할 수 있습니다.

제12조 (서비스의 제공 등)

1. 회사는 회원에게 다음 각 호의 서비스를 제공합니다.
    1.1. 홀덤 대회 정보 검색 및 등록 서비스
    1.2. 커뮤니티 게시판 및 댓글 기능
    1.3. 미디어 콘텐츠(뉴스, 영상 등) 열람 서비스
    1.4. 이벤트 및 포인트 적립·사용 기능
    1.5. 알림 기능, 푸시 메시지, 마이페이지 관리 기능
    1.6. 기타 회사가 자체 개발하거나 제휴를 통해 회원에게 제공하는 일체의 부가 서비스
2. 회사는 서비스의 효율적 제공을 위해, 일부 서비스 또는 기능을 일정 범위로 분할하여 각각 이용 가능 시간을 별도로 지정할 수 있으며, 이 경우 사전에 공지합니다.
3. 서비스는 연중무휴, 1일 24시간 제공을 원칙으로 합니다. 단, 시스템 점검, 서버 교체, 네트워크 장애 또는 기타 불가피한 사정이 있는 경우, 서비스 제공이 일시적으로 중단될 수 있습니다.
4. 회사는 전항의 사유로 서비스 제공을 일시적으로 중단할 경우, 제9조(회원에 대한 통지)에서 정한 방법에 따라 사전 또는 사후에 회원에게 안내합니다. 단, 사전에 통지할 수 없는 긴급한 사유가 있는 경우에는 사후에 통지할 수 있습니다.
5. 회사는 서비스의 안정적인 제공을 위해 정기적인 점검을 실시할 수 있으며, 점검 시간은 프리플랍 앱 내 공지사항 화면을 통해 사전에 안내합니다.

제13조 (서비스의 변경)

1. 회사는 운영상 또는 기술상 상당한 필요가 있는 경우, 제공 중인 서비스의 전부 또는 일부를 변경할 수 있습니다.
2. 서비스의 내용, 이용 방법, 이용 시간 등에 변경이 있을 경우, 회사는 변경 사유 및 변경될 서비스의 내용과 적용 일자 등을 프리플랍 앱 내 공지사항 또는 초기 화면 등을 통해 사전에 안내합니다.
3. 회사는 무료로 제공하는 서비스의 전부 또는 일부에 대하여, 정책 변경, 운영상 필요, 기술적 사유 등에 따라 수정·중단·변경할 수 있으며, 이로 인해 회원에게 별도의 보상을 하지 않습니다. 단, 관련 법령에 특별한 규정이 있는 경우에는 그에 따릅니다.

제14조 (정보의 제공 및 광고의 게재)

1. 회사는 회원이 서비스 이용 중 필요하다고 판단되는 다양한 정보를 공지사항, 앱 알림(Push), 전자우편 등의 방법으로 제공할 수 있습니다. 단, 회원은 관련 법령에 따른 거래 관련 정보, 고객문의 회신 등 필수 고지 사항을 제외하고, 홍보성 정보에 대해서는 언제든지 수신을 거절할 수 있습니다.
2. 제1항의 정보를 전화, 문자메시지(SMS), 모사전송(FAX) 등의 수단으로 전송하는 경우에는관련 법령에 따라 사전에 회원의 동의를 받아야 합니다. 단, 거래 관련 알림 및 고객 응대 목적의 연락은 이에 포함되지 않습니다.
3. 회사는 서비스 운영을 위해 앱 화면, 공지사항, 전자우편, 푸시 알림 등 다양한 방식으로 광고를 게재할 수 있습니다. 광고가 포함된 전자우편을 수신한 회원은 언제든지 수신 거절을 요청할 수 있습니다.
4. 이용자(회원 및 비회원 포함)는 회사가 제공하는 서비스와 관련하여 광고를 포함한 콘텐츠 및 정보에 대해 임의로 변경·수정·제한하는 등의 행위를 해서는 안 됩니다.

제15조 (게시물의 저작권)

1. 회원이 프리플랍 서비스 내에 게시한 텍스트, 이미지, 영상, 링크 등 일체의 콘텐츠(이하 “게시물”)에 대한 저작권은 해당 게시물의 **작성자(회원 본인)**에게 귀속됩니다.
2. 회원이 게시한 게시물은 서비스 내 검색 결과, 커뮤니티 피드, 대회 관련 콘텐츠, 프로모션 영역 등에 노출될 수 있으며, 이 경우 회사는 해당 노출을 위해 필요한 범위 내에서 게시물을 일부 수정·복제·편집하여 사용할 수 있습니다. 단, 회사는 저작권법 등 관련 법령을 준수하며, 회원은 언제든지 게시물 삭제, 검색 결과 제외, 비공개 설정 등의 조치를 직접 하거나 고객센터를 통해 요청할 수 있습니다.
3. 회사가 제2항의 범위를 넘어, 게시물을 외부 제휴 매체 또는 상업적 목적 등으로 활용하고자 할 경우, 회원에게 사전 동의를 개별적으로 요청하고 이를 명확히 받은 후에만 사용할 수 있습니다.

제16조 (게시물의 관리)

1. 회원이 서비스 내에 게시한 게시물이 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『저작권법』 등 관련 법령에 위반되는 내용을 포함하는 경우,정당한 권리자는 관련 법령이 정한 절차에 따라 해당 게시물의 삭제 또는 게시중단을 요청할 수 있으며, 회사는 그에 따라 지체 없이 필요한 조치(삭제, 차단 등)를 취합니다.
2. 회사는 권리자의 요청이 없는 경우라도, 다음 각 호에 해당한다고 판단될 경우에는 사전 통지 없이 해당 게시물에 대해 임시조치, 삭제, 노출 제한 등의 조치를 취할 수 있습니다.
    2.1. 제3자의 권리(저작권, 초상권, 명예 등)를 침해하거나 침해가 우려되는 경우
    2.2. 음란, 혐오, 폭력 등 미풍양속에 반하거나 공공질서에 위배되는 경우
    2.3. 허위 정보, 광고성 게시물, 유사수신 행위, 도박 조장 등 불법적이거나 부당한 목적의 경우
    2.4. 회사의 운영 정책, 이용약관에 위반되는 경우
3. 제1항 및 제2항에 따른 세부적인 처리 절차는 관련 법령에서 정한 범위 내에서, 회사가 별도로 운영하는 ‘게시중단 요청 절차(게시중단요청서비스)’ 및 커뮤니티 운영정책에 따릅니다

제17조 (권리의 귀속)

1. 프리플랍 서비스 및 그에 관련된 소프트웨어, 디자인, 텍스트, 이미지, UI, DB, 상표 등 모든 콘텐츠에 대한 저작권 및 지적재산권은 회사에 귀속됩니다. 단, 회원이 직접 작성한 게시물 및 제휴 계약에 따라 제공된 저작물은 제외됩니다.
2. 회사는 회원에게 서비스 이용과 관련하여, 회사 내부 정책에 따라 계정, 아이디(ID), 콘텐츠, 포인트 등에 대한 이용 권한(라이선스)만을 부여하며, 회원은 이를 양도, 판매, 대여, 담보 제공 등 처분하거나 상속 대상으로 삼을 수 없습니다.

제18조 (포인트)

1. 회사는 서비스의 효율적인 운영 및 회원 혜택 제공을 위하여, 회원에게 일정 조건에 따라 **포인트(가상의 데이터)**를 부여할 수 있습니다. 포인트는 현금 가치가 없으며, 회사가 정한 목적과 범위 내에서만 사용할 수 있습니다.
2. 회사는 사전 공지 후 포인트의 적립, 사용, 차감 기준 등을 변경하거나 일부 또는 전부를 조정할 수 있으며, 이로 인해 회원에게 불이익이 발생하더라도 회사는 별도의 보상을 하지 않습니다.
3. 포인트는 회사가 정한 유효기간 내에 사용되어야 하며, 유효기간이 경과한 포인트는 자동으로 소멸됩니다. 유효기간, 소멸 기준 등은 서비스 내 공지사항 또는 운영정책을 통해 별도로 안내합니다.
4. 회원 탈퇴, 자격 상실 등으로 이용계약이 종료되는 경우, 보유 중인 포인트는 자동 소멸되며 현금 또는 다른 수단으로 환급되지 않습니다.

제19조 (계약 해제, 해지 등)

1. 회원은 언제든지 프리플랍 앱 내 '내 정보 관리' 또는 '고객센터' 메뉴를 통해 이용계약 해지를 신청할 수 있으며, 회사는 관련 법령 및 개인정보처리방침에 따라 신속하게 계약 해지 절차를 처리합니다.
2. 회원이 이용계약을 해지할 경우, 관련 법령 및 개인정보처리방침에서 정한 바에 따라 회사가 일정 기간 회원 정보를 보유할 수 있는 경우를 제외하고, 회원의 모든 개인정보 및 서비스 이용 데이터는 지체 없이 삭제 또는 파기됩니다.

제20조 (이용제한 등)

1. 회사는 회원이 본 약관의 의무를 위반하거나, 서비스의 정상적인 운영을 방해한 경우, 경고, 일시정지, 기능 제한, 영구 이용정지 등의 단계적 조치를 통해 서비스
이용을 제한할 수 있습니다.
2. 다음 각 호에 해당하는 행위는 즉시 사전 경고 없이 영구 이용정지 조치가 될 수 있으며, 해당 조치 시 서비스 이용을 통해 적립된 포인트 및 기타 혜택은 모두 소멸되며 별도 보상하지 않습니다.
    2.1. 『주민등록법』을 위반한 실명 도용, 명의 도용
    2.2. 『저작권법』, 『컴퓨터프로그램보호법』을 위반한 불법 프로그램 배포 및 서비스 운영 방해
    2.3. 『정보통신망법』을 위반한 해킹, 악성코드 배포, 접속권한 초과 행위
    2.4. 유사수신, 불법 도박, 불법 금융광고 등 관련 법령에 위반되는 행위
    2.5. 기타 관계 법령 및 공공질서에 반하는 중대한 위반 행위
3. 회원이 3개월 이상 로그인하지 않을 경우, 회사는 회원 정보 보호 및 서비스 운영 효율화를 위하여, 일시적으로 이용을 제한하거나 휴면 계정으로 전환할 수 있습니다.
4. 이용제한의 세부 기준, 단계, 절차는 프리플랍의 ‘이용제한 정책’ 및 각 개별 서비스의 운영정책에 따릅니다.
5. 회사는 본 조에 따라 이용제한 또는 계약 해지를 할 경우, 제9조(회원에 대한 통지)에서 정한 방법에 따라 회원에게 통지합니다.
6. 회원은 회사가 정한 절차에 따라 이용제한 조치에 대한 이의신청을 할 수 있으며, 회사는 해당 이의신청이 정당하다고 판단하는 경우 즉시 서비스 이용을 재개합니다.

제21조 (책임제한)

1. 회사는 천재지변, 전쟁, 테러, 정전, 네트워크 장애 등 불가항력적인 사유로 인해 서비스를 제공할 수 없는 경우, 그에 대한 책임이 면제됩니다.
2. 회사는 회원의 귀책사유(단말기 오류, 네트워크 설정 미비, 계정 관리 부주의 등)로 인해 발생한 서비스 이용 장애에 대해서는 책임을 지지 않습니다.
3. 회사는 회원이 서비스 내에 작성하거나 게시한 정보, 자료, 의견, 사실 등의 신뢰도, 정확성, 완전성 등에 대해 어떠한 보증이나 책임도 부담하지 않습니다. 회원은 모든 게시물의 내용을 자신의 판단과 책임 하에 이용해야 합니다.
4. 회사는 회원 간 또는 회원과 제3자 간에 서비스 또는 커뮤니티 기능을 매개로 이루어진 거래, 분쟁, 연락 등 일체의 사항에 대해 책임을 지지 않습니다.
5. 회사는 무료로 제공되는 서비스에 관하여, 관련 법령에 특별한 규정이 없는 한, 회원에게 어떠한 손해에 대해서도 법적 책임을 부담하지 않습니다.

제22조 (준거법 및 재판관할)

1. 회사와 회원 간에 발생한 서비스 이용 관련 분쟁에 대해서는 대한민국 법을 준거법으로 합니다.
2. 회사와 회원 간에 발생한 분쟁에 관한 소송은, 제소 당시 회원의 주소지를 관할하는 지방법원을 전속 관할법원으로 하며, 주소가 없는 경우에는 거소지를 기준으로 합니다. 만약 주소 또는 거소가 명확하지 않은 경우에는 민사소송법에서 정한 바에 따릅니다.
3. 해외에 주소 또는 거소를 두고 있는 회원의 경우, 회사와 해당 회원 간에 발생한 분쟁은 제2항에도 불구하고 대한민국 서울중앙지방법원을 제1심의 전속 관할법원으로 합니다.

부칙

1. 이 약관은 2025년 5월 2일부터 적용됩니다.
`